/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VendorAttributeRatingTypes = 'YesNo' | 'Grade' | 'Automatic' | 'NoRating';

export const VendorAttributeRatingTypes = {
    YesNo: 'YesNo' as VendorAttributeRatingTypes,
    Grade: 'Grade' as VendorAttributeRatingTypes,
    Automatic: 'Automatic' as VendorAttributeRatingTypes,
    NoRating: 'NoRating' as VendorAttributeRatingTypes
};

